export default __webpack_public_path__ + "static/seo-logo-5dde55d0d78a182234e43c43cb39d4e2.png";